<template>
  <div v-if="!isLoadingInit">
    <b-row>
      <b-col class="mx-auto" cols="12" sm="10" md="8">
        <!-- action create new, select groups -->
        <b-container>
          <b-row v-if="!viewAdd && !viewEdit" class="my-2">
            <b-col class="my-5">
              <label><h4>Sélectionner et ajouter des résolutions ou calatogues :</h4></label>
              <v-multiselect
                :options="options"
                group-values="items"
                group-label="group"
                :group-select="false"
                placeholder="Tapez pour rechercher"
                track-by="id"
                label="name"
                open-direction="bottom"
                select-label="Appuyez sur Entrée pour sélectionner"
                @select="onSelect"
              >
                <template slot="option" slot-scope="props">
                  <div v-if="props.option.$groupLabel">
                    <strong class="text-primary">{{ props.option.$groupLabel }}</strong>
                  </div>
                  <div v-else class="select-option-main">
                    <span class="main">{{ props.option.name }}</span>
                  </div>
                  <div v-if="props.option.type == 'catalog'" class="select-option-description">
                    <span class="item">Nombre de résolutions: {{ props.option.description }}</span>
                  </div>
                  <div v-else class="select-option-description">
                    <span class="item">{{ props.option.description }} </span>
                  </div>
                </template>
                <template slot="beforeList" class="p-2">
                  <div class="p-3 description-section" style="cursor: pointer;" @click="addPressed">
                    <div class="main-description">
                      Ajouter une nouvelle résolution.
                    </div>
                    <div class="description">
                      <font-awesome-icon icon="info-circle" />
                      cette révolution ne sera assignée à aucune catégorie
                    </div>
                  </div>
                </template>
                <span slot="noResult" class="mx-2">
                  Oops! Aucun élément trouvé. Pensez à modifier la requête de recherche.</span
                >
              </v-multiselect>
            </b-col>
          </b-row>
        </b-container>

        <appResolution
          v-if="viewAdd"
          :is-new="true"
          :is-in-meeting="true"
          :meeting-id="meetingId"
          :building-id="buildingId"
          :last-position="lastPosition"
          @cancel="cancelPressed"
          @reloadTableData="reloadTableData"
        />
        <appResolution
          v-else-if="viewEdit"
          :is-new="false"
          :is-in-meeting="true"
          :meeting-resolution-id="meetingResolutionId"
          :meeting-id="meetingId"
          :building-id="buildingId"
          :last-position="lastPosition"
          @cancel="cancelPressed"
          @reloadTableData="reloadTableData"
        />

        <appMeetingResTable
          v-else
          ref="mr-table"
          class="agv-table"
          :items="tableData"
          :items-per-page="tableItemsPerPage"
          :table-current-page="tableCurrentPage"
          :voting-categories="votingCategories"
          :majorities="majoritiesOptions"
          :meeting-id="meetingId"
          @reloadTableData="reloadTableData"
          @editPressed="editPressed"
          @deletePressed="DELETE_RESOLUTION"
          @changeItemsPerPage="changeItemsPerPage"
          @changeCurrentPage="changeCurrentPage"
        />
      </b-col>
    </b-row>

    <b-row v-if="$route.name == 'meeting-agenda'">
      <b-col class="text-right">
        <b-button v-if="!viewAdd && !viewEdit" class="button btn-blue" @click="goToMeetingPresence">
          <font-awesome-icon class="agv-button-icon" icon="chevron-right" />
          <span class="mr-1">Suivant</span>
        </b-button>
      </b-col>
    </b-row>
  </div>
  <appLoader v-else />
</template>

<script>
import appResolution from "@/components/catalogs/resolutions/Resolution";

import MeetingResolutionMW from "@/middlewares/MeetingResolution";
import MeetingResolutionORM from "@/store/orm-axios/models/MeetingResolution";

import ResolutionCatalogMW from "@/middlewares/ResolutionCatalog";
import ResolutionCatalogORM from "@/store/orm-axios/models/ResolutionCatalog";

import MajorityORM from "@/store/orm-axios/models/Majority";
import VotingCategoryORM from "@/store/orm-axios/models/VotingCategory";

import VotingCategoryMW from "@/middlewares/VotingCategory";
import MajorityMW from "@/middlewares/Majority";

import BuildingMajoritiesMW from "@/middlewares/BuildingMajorities";
import BuildingMajoritiesORM from "@/store/orm-axios/models/BuildingMajorities";

import MeetingORM from "@/store/orm-axios/models/Meeting";

export default {
  components: {
    appResolution,
    appMeetingResTable: () => import("./MeetingResTable"),
  },
  props: {
    meetingId: {
      type: String,
      default: "",
    },
    buildingId: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      tableData: [],
      MeetingResolutionMW: MeetingResolutionMW,
      MeetingResolutionORM: MeetingResolutionORM,
      viewAdd: false,
      viewEdit: false,
      meetingResolutionId: null,
      isLoadingInit: true,
      tableItemsPerPage: 10,
      tableCurrentPage: 1,
    };
  },
  computed: {
    lastPosition() {
      let result = this.$_.sortBy(this.tableData, function (obj) {
        return obj.position;
      });
      if (result.length > 0) return result[result.length - 1].position;
      // if there on resolutions
      else return 0;
    },
    mrs() {
      return MeetingResolutionORM.all();
    },
    options() {
      var resolutionsCatalogs = {
        group: "Calatogues",
        items: [],
      };
      var resolutions = {
        group: "Résolutions",
        items: [],
      };
      this.resolutionsCatalogs.forEach(catalog => {
        let sortedCatalogResolutions = this.$_.sortBy(catalog.resolutions, resolution => {
          return resolution.position;
        });

        resolutionsCatalogs.items.push({
          id: catalog.id,
          name: catalog.name,
          description: catalog.resolutions.length,
          type: "catalog",
          resolutions: sortedCatalogResolutions,
        });
        catalog.resolutions.forEach(resolution => {
          resolutions.items.push({
            id: resolution.id,
            name: resolution.name,
            description: catalog.name,
            type: "resolution",
            resolution: resolution,
          });
        });
      });

      return [resolutions, resolutionsCatalogs];
    },
    resolutionsCatalogs() {
      return ResolutionCatalogORM.query()
        .where("agency_id", this.agencyId)
        .with("resolutions", query => {
          query.with(["media"]).where("parent_resolution_id", null);
          query.orderBy("position");
          query.with("children_resolutions", query => {
            // query.orderBy("position");
            query.with("media");
          });
        })
        .orderBy("created", "desc")
        .get();
    },
    majoritiesOptions() {
      if (!this.isInMeetingUpsert) {
        return this.$_.sortBy(this.meetingDetails.MajoritiesData, m => m.name);
      }
      // NOTE: Return majorities related to building if buildingId exists
      const majorities = MajorityORM.query().orderBy("name").get();
      if (this.buildingId) {
        return this.filterMajoritiesByBuildingRelation(majorities);
      } else {
        return [];
      }
    },
    votingCategories() {
      if (!this.isInMeetingUpsert) {
        return this.meetingDetails.VotingCategoriesData;
      }
      return this.filterVotingCategories();
    },
    buildingMajorities() {
      return BuildingMajoritiesORM.query()
        .where("agency_id", this.agencyId)
        .where("building_id", this.buildingId)
        .get();
    },
  },
  watch: {
    viewAdd(val) {
      this.$emit("hideParentActionButtons", val);
    },
    viewEdit(val) {
      this.$emit("hideParentActionButtons", val);
    },
  },
  async created() {
    // Make sure that vuex is not filled with data that we don't need
    MeetingResolutionORM.deleteAll();
    this.isLoadingInit = true;

    await MeetingResolutionMW.FETCH(this.meetingId);
    await ResolutionCatalogMW.FETCH(this.agencyId);

    if (this.$route.name !== "meeting-agenda") {
      // !!!: VotingCategories are get when fetching for buildings in /meetings/meeting/Meeting.vue
      // await VotingCategoryMW.FETCH(this.buildingId);
      await MajorityMW.FETCH();
    }

    await BuildingMajoritiesMW.FETCH(this.buildingId);

    this.tableData = this.getMeetingResolutions(this.meetingId);
    // this.$refs["mr-table"].$forceUpdate();
    this.isLoadingInit = false;
  },
  beforeDestroy() {
    this.tableData = null;
    this.$emit("hideParentActionButtons", false);
    // MeetingResolutionORM.deleteAll();
  },
  methods: {
    reloadTableData() {
      var x = MeetingResolutionORM.query()
        .where("meeting_id", this.meetingId)
        .with("children_resolutions")
        .orderBy("position")
        .get();
      x = this.$_.filter(x, item => {
        return item.parent_resolution_id == null;
      });
      this.tableData = x;
    },
    getMeetingResolutions(meetingId) {
      var x = MeetingResolutionORM.query()
        .where("meeting_id", meetingId)
        .with("children_resolutions")
        .orderBy("position")
        .get();
      x = this.$_.filter(x, item => {
        return item.parent_resolution_id == null;
      });
      return x;
    },
    getMeetingResolutionById(meetingResolutionId) {
      return MeetingResolutionORM.query()
        .where("id", meetingResolutionId)
        .with("children_resolutions")
        .first();
    },
    cancelPressed() {
      this.viewAdd = false;
      this.viewEdit = false;
      this.meetingResolutionId = null;
    },
    addPressed() {
      this.viewAdd = true;
    },
    editPressed(e) {
      this.meetingResolutionId = e.id;
      this.viewEdit = true;
    },
    // action create from resolution, action create from catalogs
    onSelect(selectedOption) {
      if (selectedOption.type == "catalog") {
        this.POST_FROM_CATALOGS(selectedOption);
      } else if (selectedOption.type == "resolution") {
        this.POST_FROM_RESOLUTIONS(selectedOption);
      }
    },
    DELETE_RESOLUTION(item) {
      delete item["key"];
      this.$swal({
        info: "question",
        title: this.$t("general.delete_question"),
        text: "",
        showConfirmButton: true,
        showCancelButton: true,
        confirmButtonText: this.$t("general.message_yes"),
        cancelButtonText: this.$t("general.message_no"),
        reverseButtons: true,
        buttonsStyling: false,
        confirmButtonClass: "btn btn-primary btn-lg",
        cancelButtonClass: "btn btn-light btn-lg",
      })
        .then(res => {
          if (res.value) {
            this.$store.state.showLoaderOverlay = true;
            MeetingResolutionMW.DELETE(item)
              .then(res => {
                // delete from tableData
                var index = this.$_.findIndex(this.tableData, { id: item.id });
                this.tableData.splice(index, 1);
                this.$store.state.showLoaderOverlay = false;
              })
              .catch(err => {
                this.$store.state.showLoaderOverlay = false;
                console.log("error at delete", item, err);
              });
          } else {
            this.$store.state.showLoaderOverlay = false;
          }
        })
        .catch(err => {
          console.log("err", err);
        });
    },
    async POST_FROM_RESOLUTIONS(selectedOption) {
      let chargeGeneralVoteCategory = this.$_.filter(this.votingCategories, item => {
        return item.is_charge_generale == 1;
      });

      // NOTE: Foreach children_resolution If majority_id is not in BuildingMajority, send NULL
      let children_resolutions = [];
      selectedOption.resolution.children_resolutions.forEach(children_resolution => {
        children_resolution.majority_id = this.existInMajorities(children_resolution.majority_id)
          ? children_resolution.majority_id
          : null;
        children_resolutions.push(children_resolution);
      });

      // NOTE: prepare item for call
      var meetingResolution = {
        agency_id: selectedOption.resolution.agency_id,
        name: selectedOption.resolution.name,
        description: selectedOption.resolution.description,
        // NOTE: If majority_id is not in BuildingMajority, send NULL
        majority_id: this.existInMajorities(selectedOption.resolution.majority_id)
          ? selectedOption.resolution.majority_id
          : null,
        // ? selectedOption.resolution.majority_id
        // : this.majoritiesOptions[0]
        // ? this.majoritiesOptions[0].id
        // : null, // NOTE: required only in meeting

        // diff
        meeting_id: this.meetingId,
        resolution_id: selectedOption.resolution.id,
        voting_category_id: chargeGeneralVoteCategory[0] ? chargeGeneralVoteCategory[0].id : null,
        status: null,

        // TEST:
        media: selectedOption.resolution.media,

        children_resolutions: children_resolutions,
        position: this.lastPosition + 1,
      };

      this.$store.state.showLoaderOverlay = true;
      await MeetingResolutionMW.POST_FROM_RESOLUTIONS(meetingResolution)
        .then(res => {
          this.$store.state.showLoaderOverlay = false;
          var mtToPush = this.getMeetingResolutionById(res.id);
          this.tableData.push(mtToPush);
        })
        .catch(err => {
          this.$store.state.showLoaderOverlay = false;
          console.error("error", err);
        });
    },
    async POST_FROM_CATALOGS(selectedOption) {
      // NOTE: prepare items for call
      var startPosition = 1;
      var meetingResolutions = [];
      let position = this.lastPosition;
      let chargeGeneralVoteCategory = this.$_.filter(this.votingCategories, item => {
        return item.is_charge_generale == 1;
      });
      selectedOption.resolutions.forEach((resolution, index) => {
        position += 1;

        // NOTE: Foreach children_resolution If majority_id is not in BuildingMajority, send NULL
        let children_resolutions = [];
        resolution.children_resolutions.forEach(children_resolution => {
          children_resolution.majority_id = this.existInMajorities(children_resolution.majority_id)
            ? children_resolution.majority_id
            : null;
          children_resolutions.push(children_resolution);
        });

        meetingResolutions.push({
          agency_id: resolution.agency_id,
          name: resolution.name,
          description: resolution.description,
          // NOTE: If majority_id is not in BuildingMajority, send NULL
          majority_id: this.existInMajorities(resolution.majority_id)
            ? resolution.majority_id
            : null,
          // ? resolution.majority_id
          // : this.majoritiesOptions[0]
          // ? this.majoritiesOptions[0].id
          // : null, // NOTE: required only in meeting

          // diff
          meeting_id: this.meetingId,
          resolution_id: resolution.id,
          voting_category_id: chargeGeneralVoteCategory[0] ? chargeGeneralVoteCategory[0].id : null,
          status: null,
          media: resolution.media,
          children_resolutions: children_resolutions,
          position: position,
        });
      });

      this.$store.state.showLoaderOverlay = true;
      await MeetingResolutionMW.POST_FROM_CATALOGS(meetingResolutions)
        .then(res => {
          this.$store.state.showLoaderOverlay = false;
          this.tableData = this.getMeetingResolutions(this.meetingId);
          this.$refs["mr-table"].$forceUpdate();
        })
        .catch(err => {
          this.$store.state.showLoaderOverlay = false;
          console.log("err", err);
        });
    },
    goToMeetingPresence() {
      this.$router.push({ name: "meeting-presence" });
    },
    changeItemsPerPage(itemsPerPage) {
      this.tableItemsPerPage = itemsPerPage;
    },
    changeCurrentPage(currentPage) {
      this.tableCurrentPage = currentPage;
    },
    filterMajoritiesByBuildingRelation(majorities) {
      let filtered = [];
      this.buildingMajorities.forEach(buildingMajority => {
        let majority = this.$_.find(majorities, item => item.id == buildingMajority.majority_id);
        if (majority) filtered.push(majority);
      });
      return filtered;
    },
    existInMajorities(majorityId) {
      const found = this.$_.find(this.majoritiesOptions, item => item.id == majorityId);
      return found ? true : false;
    },
    filterVotingCategories() {
      const meeting = MeetingORM.getters("getById")(this.meetingId);
      const meetingVotingCategories = meeting ? meeting.voting_categories : [];

      const ormVotingCategories = VotingCategoryORM.getters("getByBuildingId")(this.buildingId);

      if (!meetingVotingCategories || meetingVotingCategories.length == 0) {
        return ormVotingCategories;
      }

      let filteredVotingCategories = [];
      for (const ormVotingCategory of ormVotingCategories) {
        const found = meetingVotingCategories.find(item => item == ormVotingCategory.id);
        if (found) {
          filteredVotingCategories.push(ormVotingCategory);
        }
      }
      return filteredVotingCategories;
    },
  },
};
</script>
